import { connect } from 'react-redux';
import { toggleSubmitMenu } from '../../redux/actions';
var mapDispatchToProps = {
    toggleSubmitMenu: toggleSubmitMenu,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=SubmitMenu.container.js.map